import { useState } from "react";
import GoBackComponent from "../Reusable/GoBackComponent.js";

import { UploaderSideBar } from "./UploaderSideBar.js";

import { UploaderArea } from "./UploaderArea/UploaderArea.tsx";

export const UploaderComponent = () => {
  const [sideBarOption, setSideBarOption] = useState(null);

  return (
    <>
      <GoBackComponent />
      <div
        className={`home-upload-container ${
          sideBarOption ? "with-sidebar" : ""
        }`}
      >
        <UploaderArea />
        <UploaderSideBar {...{ sideBarOption, setSideBarOption }} />
      </div>
    </>
  );
};
